import { HttpResponse } from '@angular/common/http';
import { FileDownloadOptions } from '../types/file-download-options';
import { HandleBlobHttpResponseOptions } from '../types/handle-blob-http-response-options';
import { ExportFileType } from '../app/model/enum/export-file-type';
import { ExportExcelPdfService } from '../app/services/export-excel-pdf/export-excel-pdf.service';

export function handleBlobHttpResponse(
  response: HttpResponse<Blob>,
  options?: HandleBlobHttpResponseOptions,
  exportService?: ExportExcelPdfService
): void {
  if (!response.body) {
    console.error('Response body is null or undefined');
    // Notify failure if exportService is provided
    if (exportService) {
      const exportType = options?.print ? 'print' : 'excel';
      exportService['exportCompleteSubject'].next({ type: exportType as any, success: false });
    }
    return;
  }

  const contentType =
    response.headers.get('content-type') || 'application/octet-stream';
  const filename = response.headers.get('x-filename') || 'download.bin';
  const blob = new Blob([response.body!], { type: contentType });

  const { print = false } = options ?? {};
  
  if (print) {
    printBlob(blob, exportService);
    // Notify success for print
    if (exportService) {
      exportService['exportCompleteSubject'].next({ type: 'print' as any, success: true });
    }
  } else {
    // Determine export type from filename extension
    const exportType = 
      filename.toLowerCase().endsWith('.xlsx') ? 'excel' : 
      filename.toLowerCase().endsWith('.pdf') ? 'pdf' : 'txt';
    downloadBlob({ blob, filename });
    // Notify success for download
    if (exportService) {
      exportService['exportCompleteSubject'].next({ type: exportType as any, success: true });
    }
  }
}

export function downloadBlob({ blob, filename }: FileDownloadOptions): void {
  const blobUrl = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = blobUrl;
  a.download = filename;
  a.click();

  URL.revokeObjectURL(blobUrl); // Clean up
}

export function printBlob(blob: Blob, exportService?: ExportExcelPdfService): void {
  const blobUrl = URL.createObjectURL(blob);
  const printWindow = window.open(blobUrl, '_blank');

  if (!printWindow) {
    console.error('Popup blocked. Unable to open print window.');
    if (exportService) {
      exportService['exportCompleteSubject'].next({ type: 'print' as any, success: false });
    }
    return;
  }

  printWindow.onload = () => {
    printWindow.focus();
    printWindow.print();

    // Optional cleanup after some delay
    setTimeout(() => {
      URL.revokeObjectURL(blobUrl);
    }, 3000);
  };
}
